import { TocuhPad as TocuhPad$1, TocuhPadInner, TocuhPadText } from './TouchPads.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var TocuhPad = function TocuhPad(_ref) {
  var color = _ref.color,
    priceText = _ref.priceText,
    text = _ref.text,
    isSmall = _ref.isSmall;
  if (!text) {
    return false;
  }
  var hasPriceText = !isSmall && !!priceText && priceText.length > 0;
  return /*#__PURE__*/jsx(TocuhPad$1, {
    $isSmall: isSmall,
    children: /*#__PURE__*/jsx(TocuhPadInner, {
      $colorTheme: color,
      $isSmall: isSmall,
      $hasPriceText: hasPriceText,
      children: /*#__PURE__*/jsxs(TocuhPadText, {
        $isSmall: isSmall,
        children: [text, hasPriceText && /*#__PURE__*/jsx("div", {
          children: priceText
        })]
      })
    })
  });
};
TocuhPad.defaultProps = {
  color: null,
  priceText: null,
  isSmall: false
};
var TouchPad = TocuhPad;

export { TouchPad as default };
//# sourceMappingURL=TouchPad.js.map
